import { takeLatest, select, put } from 'redux-saga/effects';
import { RootState } from 'data';
import {
  createProjectTemplateSubTask,
  createProjectTemplateTask,
} from 'data/templates/projects/slices';
import { TemplateId } from '../api';
import {
  allocationsBulkAction,
  updateAllocatedMembersAction,
} from '../projects/actions';
import { templateSlice } from '../slices';

const { setDirtyState } = templateSlice.actions;

const selectCurrentPathName =
  () =>
  ({ router }: RootState): string =>
    router.location.pathname.split('/')[3];

const checkProjectToTemplate =
  () =>
  ({ templates }: RootState): boolean =>
    templates.project.projectToTemplate;

const PROJECT_TEMPLATE_ACTION = '@@TEMPLATES/PROJECT/';
const DOCUMENT_TEMPLATE_ACTION = '@@TEMPLATES/DOCUMENT/';

function* watchAllTemplateSaga(): Generator {
  const currentPageId = (yield select(selectCurrentPathName())) as string;
  const isProjectToTemplate = yield select(checkProjectToTemplate());
  const dirtyObjectToSend: {
    id: TemplateId;
  } = {
    id:
      currentPageId === 'new' || isProjectToTemplate
        ? 'new'
        : parseInt(currentPageId, 10),
  };

  yield put(setDirtyState(dirtyObjectToSend));
}

export function* watchAllTemplateChangesSaga(): Generator {
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}updateProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}createProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}updateProjectTemplateProjectPhase`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}updateProjectTemplateTask`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}updateProjectTemplateProjectPhases`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}updateProjectTemplateTasks`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}deletePhaseInProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}shiftStartDayProjectPhaseInProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}addProjectTemplateTaskDependency`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}addProjectTemplatePhaseDependency`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}updateTaskInProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(createProjectTemplateTask.type, watchAllTemplateSaga);
  yield takeLatest(createProjectTemplateSubTask.type, watchAllTemplateSaga);
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}createPhaseInProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}updateProjectTemplateParentOfTask`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}updateSpaceInProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}deleteSpaceInProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}setupSpaceTabsOnSpaces`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}deleteProjectTemplateSpaceTab`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${DOCUMENT_TEMPLATE_ACTION}createDocumentTemplateAction`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${DOCUMENT_TEMPLATE_ACTION}updateDocumentTemplateAction`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${DOCUMENT_TEMPLATE_ACTION}updateDocumentTemplateContentAction`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${DOCUMENT_TEMPLATE_ACTION}createDocumentTemplateTaskAction`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${DOCUMENT_TEMPLATE_ACTION}deleteDocumentTemplateTaskAction`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}JiraMapping`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}dynamicConditions`,
    watchAllTemplateSaga,
  );
  yield takeLatest(
    `${PROJECT_TEMPLATE_ACTION}deleteTaskInProjectTemplate`,
    watchAllTemplateSaga,
  );
  yield takeLatest(allocationsBulkAction, watchAllTemplateSaga);
  yield takeLatest(updateAllocatedMembersAction, watchAllTemplateSaga);
}
